<template>
  <div class="about-company __box-wrap">
    <div class="__layout-wrap">
      <ul class="__layout-tab">
        <li
          v-for="(vo,idx) in tab"
          :key="vo"
          :class="{ 'on': idx == act }"
          @click="toggleTab(vo,idx)"
        >{{ vo }}
        </li>
      </ul>
      <div class="__layout-container">
        <div class="__layout-headline">{{ headline }}</div>
        <div class="__layout-content">

          <!-- 用户协议 -->
          <div
            v-if="act == 0"
            class="about">
            <p>欢迎您与上海图魂网络科技有限公司（以下简称“潮国创意”）共同签署本《用户服务协议》（下称“本协议”）并使用潮国创意网站服务，“潮国创意”是指潮国创意（chaopx.com）的运营公司及其关联公司，
              《潮国创意用户协议》（以下简称“本协议”）是您与上海图魂网络科技有限公司之间关于使用潮国创意各项服务的法律协议，《潮国创意隐私政策》、《版权声明》、《潮国创意VIP服务协议》以及潮国创意
              公布的其他协议规范、规则、声明、公告、政策等（以下统称“潮国创意其他规则”）是本协议不可分割之组成部分，您在使用潮国创意服务时应同样遵守。您接受并同意本协议的行为即视为您同意并接受其他
              潮国创意规则，您接受并同意任一其他潮国创意规则的行为亦视为您接受并同意本协议。
            </p>

            <p>潮国创意已采用字体加粗的方式来特别提醒您注意本协议中与您的权益（可能）存在重大关系的条款（包括免除潮国创意责任的条款、限制您权利的条款、争议解决条款及司法管辖条款等），请您留意重点查
              阅。请您确保您在使用潮国创意服务前已仔细阅读、充分理解并毫无保留地接受本协议所有条款，各条款标题仅为帮助您理解该条款表达的主旨之用，不影响本协议条款之解释或相关条款的含义，如您就相关
              条款存在疑问的，请您及时向潮国创意客服咨询。当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与潮国创意达成一致，
              成为潮国创意网站“用户”。如您不同意本协议中任何条款约定，您应立即停止注册程序；如您未申请注册流程，或者在本协议生效前已成为潮国创意的注册用户，则您通过访问或使用潮国创意，即视为您默示
              同意接受本协议的全部内容，否则请您停止访问或使用潮国创意平台。</p>

            <p>请您确认您具备完全民事权利能力和完全民事行为能力，有能力同意并遵守本协议，并对您本协议项下的全部行为独立承担法律责任。若您不具备前述与您行为相适应的民事行为能力，则应获得法定监护人的
              知情同意。如您尚未成年，请在法定监护人的陪同下阅读和判断是否同意本协议，请特别注意未成年人条款。未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可。</p>

            <p>一、协议范围 <br>
              本协议由您与潮国创意经营者（上海图魂网络科技有限公司）共同缔结，您执行并同意您已详细阅读本协议并自愿受本协议相关条款之约束，上述行为为您真实的意思表示。本协议项下，潮国创意经营者可能
              根据潮国创意的业务调整而发生变更，变更后的潮国创意经营者与您共同履行本协议并向您提供服务，潮国创意经营者的变更不会影响您本协议项下的权益。</p>

            <p>二、服务概述 <br>
              1、概述 <br>
              因潮国创意存在众多服务类别，不同用户所获取的服务因自身选择而有所不同，本协议仅为一般性用户服务条款。就潮国创意所提供的某些/某类特定产品/服务，潮国创意有权制定特定用户服务协议以便您可
              以更加具体、详细了解相关服务，您应在充分阅读并同意特定用户服务协议的全部内容后再使用该特定产品/服务。<br><br>

              2、服务修改、升级 <br>
              由于互联网行业高速发展，您与潮国创意签署的本协议列明的条款并不能完整罗列并覆盖您与潮国创意所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，潮国创意公示的相关声明及政
              策、潮国创意相关的规则和协议均为本协议的补充协议，与本协议不可分割且具有同等法律效力。潮国创意有权通过公告（包括但不限于网站首页公告、系统消息、网页弹窗）、短信提醒、邮箱提醒等方式向
              您发送潮国创意页面改版、服务升级、服务改版等通知，如您拒绝接受上述改动的，请您立即停止使用相关服务，您的使用行为视为您同意潮国创意服务修改、升级。 <br><br>

              3、服务说明 <br>
              （1）潮国创意向您提供包括但不限于如下服务：<br>
              ①潮国创意网站服务（chaopx.com）；<br>
              ②潮国创意（付费）会员服务（下称“会员服务”）；潮国创意有权就不同等级付费用户提供相应的会员服务，潮国创意会在您开通、使用付费服务前予以明确提示，当且仅当您依据提示确认您愿意支付并开通
              相关服务时，您才有权使用该等收费网络服务，如您拒绝支付相关费用的，则潮国创意有权拒绝向您提供此等付费服务。<br>
              ③潮国创意用户个人中心等；<br>
              ④潮国创意搜索服务（下称“搜索服务”）；<br>
              ⑤潮国创意下载服务（下称“下载服务”）；<br>
              ⑥潮国创意提供的其他技术和/或服务（下称“其他技术和服务”），具体以潮国创意实际提供的为准。<br>

              （2）潮国创意为您提供的服务均限于上述潮国创意网站（chaopx.com）内使用，任何以恶意破解等非法手段将潮国创意所提供的服务与潮国创意网站分离的行为皆不属于本协议约定的由潮国创意提供的服务，
              由此引起的一切后果由行为人负责；潮国创意所提供的服务仅限用户于约定范围内使用，用户在未经潮国创意事先书面许可的情况下，不得超出相应范围使用潮国创意提供的服务，潮国创意将保留依法追究行为
              人法律责任的权利。<br><br>

              4、服务变更、中断或终止 <br>

              （1）鉴于网络服务的特殊性，您理解并同意，潮国创意有权基于经营策略的调整随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。如变更、中断或终止的网络服务属于免费网络服务的，潮
              国创意无需通知您，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的网络服务属于付费网络服务的，潮国创意将在变更、中断或终止之前事先通知用户。<br>

              （2）您理解并知悉，潮国创意需要定期或不定期地对提供网络服务的平台（如互联网网站）或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，潮国创意无需为此承担任
              何责任，但潮国创意将尽可能事先进行通告。 <br>

              （3）如潮国创意发生合并、分立、收购、资产转让时，潮国创意可向第三方转让本服务下相关资产；潮国创意亦可在单方通知您后，将本协议下部分或全部服务及相应的权利义务转交由第三方运营或履行。 <br>

              （4）如您实施违反法律法规、违背公序良俗，违反本协议或潮国创意其它协议，侵害他人合法权益等行为的，或您的使用行为影响或可能影响潮国创意或他人合法权益的，潮国创意有权不经通知而单方中断或
              终止向您提供全部或部分服务，如发生下列任何一种情形，潮国创意有权随时中断或终止向用户提供本协议项下的网络服务（包括收费网络服务）而无需对用户或任何第三方承担任何责任： <br>

              ①用户提供的个人资料不真实；<br>

              ②用户违反本协议中相关条款的；<br>

              ③用户在使用收费网络服务时未按规定向潮国创意支付相应的服务费的；<br>

              ④用户存在其它违反相关法律法规、违反本协议相关约定的。<br>

              （5）潮国创意终止向您提供服务后，有权根据适用法律的要求删除您的个人信息，亦有权依照法律规定的期限和方式继续于潮国创意平台保留您的相关信息以便保障潮国创意合法权益。<br><br>

              5、其他服务规范<br>

              （1）为方便您使用潮国创意和潮国创意关联公司的其他相关服务，您授权潮国创意将您在账户注册和使用潮国创意服务过程中提供、形成的信息传递给潮国创意关联公司等其他相关服务提供者，或从潮国创意
              关联公司等其他相关服务提供者获取您在注册、使用相关服务期间提供、形成的信息。 您同意潮国创意在提供服务的过程中以各种方式投放商业性广告或其他任何类型的商业信息（包括但不限于在潮国创意的
              任何位置上投放广告，在您上传、传播的内容中投放广告），您同意接受潮国创意通过电子邮件、站内短信、手机短信、网站公告或其他方式向您发送促销或其他相关商业信息。<br>

              （2）第三方链接 <br>

              潮国创意可能会提供与其他国内/国际互联网网站或资源进行链接。除非另有声明，潮国创意无法对第三方网站之服务进行控制，用户因使用或依赖上述网站或资源所产生的损失或损害应由用户自行承担，潮国
              创意不承担任何责任。我们建议您在离开潮国创意，访问其他网站或资源前仔细阅读其服务条款和隐私政策。 </p>

            <p>三、账户注册与使用 <br>

              1、账号注册 <br>

              （1）部分潮国创意服务仅向注册用户提供，如果您需使用潮国创意服务的，请先根据本协议及其他服务规则依据注册流程成为注册用户，并确保您所提交的包括但不限于姓名、手机号、联系地址、证件号码等
              注册信息真实、合法、完整、有效，为了更好的为您提供服务以及确保您的账户安全，您同意并授权潮国创意可以根据您提供的手机号码、身份证号码等信息向全国公民身份号码查询服务中心、电信运营商、
              金融服务机构等可靠单位发起用户身份真实性、用户手机号码有效性状态等情况的查询，如上述注册信息发生变化的，请您及时修改，因您怠于修改、拒绝修改产生的不利后果由您自行承担。您有权使用您设置
              或确认的潮国创意会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录潮国创意。由于您的潮国创意账户关联您的个人信息及潮国创意商业信息，您的潮国创
              意账户仅限您本人使用。未经潮国创意同意，您直接或间接授权第三方使用您潮国创意账户或获取您账户项下信息的行为自始无效。如潮国创意判断您账户的使用可能危及您的账户安全及/或潮国创意信息安全
              的，潮国创意可拒绝提供相应服务或终止本协议，您应对您所获得的潮国创意账号项下的一切行为承担全部责任。<br>

              （2）潮国创意官方所公布的方式为注册、登录、使用潮国创意服务的唯一合法方式，用户通过其他任何途径、任何渠道、任何方式获取的潮国创意服务（包括但不限于账号注册、VIP服务获取）均为非法取得，
              一经发现，潮国创意有权立即采取注销、封禁账号、撤销授权等措施，任何因此导致的一切不利后果均由用户自行承担。请您妥善保管自己的账号和密码，因您所使用的账号被泄露或被盗而造成的任何不利后果
              均由您自行承担。<br>

              2、使用权限<br>

              您理解并同意，您仅享有潮国创意账号及账号项下潮国创意所提供的产品及服务的使用权，该账号及相关产品、服务的所有权及知识产权等仍归属于潮国创意，但法律法律另有规定的除外。由于用户账户关联用
              户信用信息，仅当有法律明文规定、司法裁定或经潮国创意同意，并符合潮国创意规则规定的用户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您
              的账户不得以任何方式处置上述账号（包括但不限于赠与、出借、转让、销售、抵押、继承、许可他人使用）。如潮国创意发现或者有合理理由认为您并非账号初始注册人的，潮国创意有权在不通知您的情况下
              暂停或终止向您提供服务并注销该账号。<br>

              3、实名认证<br>

              作为潮国创意经营者，为使您更好地使用潮国创意的各项服务，保障您的账户安全，潮国创意可要求您按潮国创意要求及我国法律规定完成实名认证。<br>

              4、账户安全<br>

              （1）您应妥善保管好您所获得的潮国创意账号，除潮国创意存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。如您发现任何未
              经授权使用您账户登录潮国创意或其他可能导致您账户遭窃、遗失的情况，请您立即通知潮国创意。您理解潮国创意对您的任何请求采取行动均需要合理时间，除潮国创意存在过错外，潮国创意对在采取行动前
              已经产生的不利后果不承担任何责任。<br>

              （2）您知悉并同意：<br>
              ①当您的账号或密码遭到未经授权的使用，或者发生任何安全问题时，您会立即及时准确与潮国创意取得沟通；<br>
              ②您在使用潮国创意账号后应及时退出相关登陆；<br>
              ③您同意潮国创意可通过电子邮件、客户端、网页、短信通知或其他合法方式向您发送通知信息和其他相关信息。<br>

              （3）您确保不会实施如下行为：<br>
              ①冒用他人信息注册潮国创意账号；<br>
              ②未经他人合法授权以他人名义注册潮国创意账号；<br>
              ③窃取、盗用他人潮国创意账号及账号下相关产品、服务；<br>
              ④使用侮辱、诽谤、色情、政治等违反法律、道德及公序良俗的词语注册潮国创意账号；<br>
              ⑤以非法占有潮国创意相关产品或服务为目的，通过正当或非正当手段恶意利用网站漏洞；<br>
              ⑥其它侵犯潮国创意或他人合法权益的。<br>

              您理解并同意，潮国创意有权对违反上述条款的用户作出禁止注册及/或封号的处理。<br>

              5、账号分立<br>
              （1）同一主体拥有的QQ帐号及微信帐号，在进行潮国创意登录时，将被识别为两个独立的帐号；<br>
              （2）同一主体拥有的多个QQ帐号并进行潮国创意VIP会员登录的，每一个QQ帐号将被识别为一个独立的帐号；<br>
              （3）同一主体拥有多个微信帐号并进行潮国创意会员登录的，每一个微信帐号将被识别为一个独立的帐号；<br>
              （4）每个帐号之间的充值记录、VIP权限无法进行迁徙、转让、赠与、售卖、租借、分享，无论该等帐号是否由同一使用人拥有，请您在登录/充值/参加活动时注意区分，避免造成损失。由此造成的损失由您自行
              承担。<br>

              6、账号回收<br>

              （1）您理解并同意，如您的账户长期未登录，潮国创意有权在法律允许的最大范围内视情况决定收回账号使用权，潮国创意有权就相关账号进行注销，您的账户将不能再登录潮国创意，相应服务同时终止，此等行
              为无需另行征得您的同意，但潮国创意将在对此类账户进行清理前通过包括但不限于网站公告、站内消息等方式通知您。 </p>

            <p>四、网站内容 <br>

              1、潮国创意网站内容是指潮国创意网站所展示、传播的包括美术作品、摄影作品等，上述内容由潮国创意所提供，上述内容由提供者、上传者对其真实性、合法性承担全部责任。如您认为相关内容侵犯您的合法权
              益的，您可通过与潮国创意客服沟通或向潮国创意发送相关邮件要求潮国创意删除相关作品，潮国创意将在收到您的邮件后于合理期限内核实相关情形，如您所述情形属实的，潮国创意将及时下线相关作品避免为您
              带来损失。但您知悉并同意，如上传人提供反通知且经潮国创意查证属实的，潮国创意有权恢复相关链接，由此产生的纠纷由您与上传人自行解决。<br>

              # 潮国创意联系方式：248172239@qq.com <br>

              2、潮国创意已设置专业人员就所展示、传播的内容进行审查，但您已知悉，潮国创意内容数量繁多且来源广泛，或存在潮国创意无法预先知晓并合理控制的内容，因此，您已预知在使用潮国创意服务时可能会接触
              到部分令您感到不快、不适或厌恶的内容，您同意放弃由此产生的针对潮国创意的任何追索权。潮国创意不对用户在潮国创意上传、发布或传输的任何内容和信息背书、推荐或表达观点，也不对任何内容和信息的
              错误、瑕疵及产生的损失或损害承担任何责任，您对内容和信息的任何使用需自行承担相关的风险。如您认为相关内容存在违反相关法律法规、侵害您合法权益的，您可通过潮国创意所公示的联系方式通知潮国创
              意停止传输任何前述内容并采取相应处理措施。<br>

              3、潮国创意有权就您使用潮国创意服务，于相关产品中使用潮国创意内容，尊重知识产权行为于潮国创意相关页面、潮国创意推广合作平台进行事实性陈述，潮国创意保证所陈述内容不涉嫌夸大宣传、虚假宣传等，
              上述行为不会损害您的既有权利。</p>

            <p>五、使用规则 <br>
              1、用户在使用潮国创意网络服务过程中，应当遵循以下原则：<br>
              （1）遵守中华人民共和国相关法律法规；<br>
              （2）遵守所有与潮国创意网络服务有关的网络协议、规定和程序；<br>
              （3）不得为任何非法目的而使用网络服务系统，不得利用潮国创意网络服务系统进行任何可能对互联网正常运转造成不利影响的行为；<br>
              （4）不得利用潮国创意提供的网络服务展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；<br>
              （5）不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权、肖像权、隐私权、物权或其他任何合法权益；<br>
              （6）不得使用互联网爬虫、蜘蛛软件等脚本、程序进行内容的窃取，不得避开、绕过潮国创意设置的相关网络限制使用潮国创意服务，不得利用潮国创意网络服务系统进行任何不利于潮国创意的行为；<br>
              （7）不得实施任何危害未成年人的行为；<br>
              （8）如您发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告潮国创意。<br>
              （9）网络用户下载潮国创意的作品，应在作品的授权许可范围内使用，不得超出授权范围使用，不得侵害潮国创意及权利人合法权益。<br>

              如您所实施的行为违反上述条款的，由此产生的一切不利后果均由您自行承担，如因此造成潮国创意损失的，您应消除影响并赔偿潮国创意因此产生的一切损失。<br>

              2、您不得通过任何渠道或媒体（包括但不限于自媒体等）发出“与潮国创意合作”、“与潮国创意共同出品”等任何携带“潮国创意”品牌的字样，不得擅自使用“潮国创意”商标、LOGO等。您使用潮国创意的行为不得视为
              潮国创意就您的使用行为进行背书，如您需与潮国创意进行品牌合作推广的，请您另行联系潮国创意商务部门洽谈相关合作事宜。<br>

              3、费用<br>

              潮国创意为潮国创意平台向您提供的服务付出了大量的成本，潮国创意有权根据潮国创意相关规则向您收取一定费用作为网站维护的费用。<br>

              4、违约赔偿<br>
              您理解并同意，您应承担保障和维护潮国创意及其他用户的利益的义务，如因您使用潮国创意的行为违反相关法律法规，损害任意第三方合法权益或存在违反本协议及潮国创意其它协议的，您应承担由此造成的一切不利
              后果（包括但不限于律师费用、诉讼费、仲裁费及其他合理费用）。</p>

            <p>六、知识产权 <br>

              1、潮国创意作品均受国际版权公约、中华人民共和国著作权法、专利法、及其他知识产权方面的法律法规的保护，潮国创意服务及本服务所使用的软件、技术、商标、材料等的所有知识产权归潮国创意所有。<br>
              2、用户不得修改、改编、翻译潮国创意服务所使用的软件、技术、材料等，或者创作与之相关的衍生作品，不得恶意修改、复制、传播潮国创意服务所使用的软件、技术、材料，不得通过反向工程、反编译、反汇编或其
              他类似行为获得其的源代码，否则由此引起的一切法律后果由用户负责，潮国创意将依法追究违约方的法律责任。<br>
              3、潮国创意就网站所展示的原创内容和其他通过授权取得的内容享有知识产权，未经潮国创意许可，任何单位和个人不得实施转载、传播、使用等侵犯潮国创意知识产权的行为。否则，潮国创意将追究侵权行为人的法律责任。<br>
              4、用户不得擅自删除、掩盖或更改潮国创意的版权声明、商标或其它权利声明。不得未经许可擅自使用潮国创意商标、标识。<br>
              5、您仅获得潮国创意内容于一定授权范围内的，一定期限内的使用权限，潮国创意内容的所有权及知识产权仍由潮国创意或原权利人享有，您与潮国创意达成的任何协议不得视为相关权利的移转。</p>

            <p>七、免责声明 <br>

              1、您已知悉并同意，潮国创意就其网站所展示的非潮国创意广告或相关信息的真实性不予任何保证，如您经本服务上的广告、展示而存在购买、取得的任何非潮国创意产品、信息或资料的意愿的，潮国创意在此提醒您详细
              阅读相关产品的信息并自行判断是否购买、取得相关产品，潮国创意就您通过上述渠道所进行产品的选购行为不承担任何责任，潮国创意就相关产品的质量、服务等不作任何保证，您应自行承担由此产生的一切不利后果。<br>
              2、您已知悉并同意，潮国创意有权在不同时间依据自身商业模式就相关服务内容、服务类别、服务费用进行调整，您所获得的相关服务范围仅限于您获取时潮国创意所提供的服务范围，您无权要求潮国创意为您开通后续新
              增服务。<br>
              3、潮国创意就如下事项不作任何担保：<br>
              （1）潮国创意无法确保您所获取的网络服务一定能满足您的要求，也无法确保网络服务不会因相关不确定因素中断，潮国创意就网络服务的及时性、安全性、准确性不作任何担保。<br>
              （2）潮国创意网站、各分类版块、子网站等虽均已经过潮国创意严格测试，但因技术本身的局限性，潮国创意不能保证其与其他软硬件、系统完全兼容。如果出现不兼容的情况，您可将情况通知潮国创意以获得技术支持。
              如果上述问题仍无法解决的，您可以选择停止使用潮国创意相关服务。<br>
              （3）因潮国创意服务使用过程中涉及到Internet服务，该服务可能会受到诸如不可抗力、黑客攻击、系统不稳定、网络中断、用户关机、通信线路等原因的负面影响，上述影响均可能造成潮国创意所提供的服务中断或
              不能满足用户要求的情况，因此潮国创意就相关服务与您需求的符合度不作任何保证。<br>
              （4）因潮国创意内容可通过网络途径下载、传播，因此就从非潮国创意所获取的服务，潮国创意就此等服务的质量不作任何担保。但因用户使用潮国创意服务下载或取得的任何资料，其风险由用户自行负担，因该使用而
              导致用户电脑系统损坏或资料流失等责任由用户自行承担。<br>
              （5）潮国创意不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由潮国创意实际控制的任何网页上的内容，潮国创意不承担任何责任。<br>
              4、对于因不可抗力或潮国创意不能控制的原因造成的网络服务中断或其它缺陷，潮国创意不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。<br>

              5、您理解并同意，对于潮国创意向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，潮国创意无需承担任何责任：<br>
              （1）潮国创意服务全部或部分无法使用的；<br>
              （2）潮国创意向用户免费提供、赠送的任何产品或服务；<br>
              （3）潮国创意向收费网络服务用户附赠的各种产品或者服务。<br>

              6、您因认证信息不真实而导致账号丢失而无法找回的，潮国创意不承担任何法律责任。您应妥善保管自己的账号和密码，加强密码安全性，谨防账号泄露或被盗。因用户账号被泄露或被盗而造成的任何损失，潮国创意
              不承担补偿责任。您因电信和网通部门的通讯线路故障、网络或电脑故障、系统不稳定、不可抗力（如服务器宕机）等非潮国创意原因造成账号丢失的，潮国创意不承担补偿责任。<br>

              7、您理解并同意您自主选择使用潮国创意服务，如您在使用潮国创意服务过程中对计算机系统造成的损坏或数据的丢失等不利后果由您自行承担。 </p>

            <p>
              八、账号注销 <br>
              1、用户有权向潮国创意提出账号注销申请，您可以通过联系潮国创意客服注销您的账号（但相关法律法规、本协议或潮国创意其它规则另有规定的除外）。潮国创意账号注销后，您将无法再通过该账号进行登录和使用
              潮国创意所有产品及服务，潮国创意将同时终止向您提供潮国创意任何产品及服务。<br>
              2、如您确定需要注销潮国创意账号的，您已充分知晓并确认，账号注销后您将不再拥有账号相关的权益，包括但不限于：<br>
              （1）账号注销后，您将无法再以该账号登录、使用潮国创意全部产品和服务，潮国创意将不再为您提供任何与账号有关的服务；<br>
              （2）账号注销后，您曾通过该账号登录、使用潮国创意服务的所有内容、信息、数据、记录将会被删除或隐匿；<br>
              （3）您选择注销您账号的行为视为您放弃该账号在潮国创意服务期限内尚未使用的任何权益，包括但不限于您账号下使用期限尚未届满的VIP服务权益，尚未使用的各类优惠券、积分等。<br>
              3、在您向潮国创意提出注销账号申请前，为确保账号可顺利注销，请您先行进行检查确保账号符合如下条件：<br>
              （1）账号为您本人所有，且通过合法渠道取得；<br>
              （2）账号不存在因违反相关法律法规或违约被暂时封禁、永久封禁；<br>
              （3）账号不存在因操作异常被暂停使用、限制使用情形；<br>
              （4）其它应满足的条件。<br>
              如您已确保上述条件完全符合，您应及时通过潮国创意首页客服通道联系客服提交您的注销申请或向潮国创意邮箱发送注销申请，潮国创意将于合理期限内处理您的注销申请。<br>
              4、您的账号注销视为您与潮国创意所签署的相关协议、其他权利义务性文件的终止（法律法规或协议中另有规定的除外）。但您知悉，账号的注销并不当然减轻或免除您在协议期间内应根据相关法律法规、相关协议、
              规则等（可能）需要承担的相关责任。
            </p>

            <p>
              九、隐私政策 <br>
              1、潮国创意注重保护用户的个人信息及个人隐私潮国创意将依据潮国创意所公示的《潮国创意隐私政策》的约定处理和保护您的个人信息，因此请您能够仔细阅读并充分理解《潮国创意隐私政策》。<br>
              2、请您仔细阅读、充分理解《潮国创意隐私政策》后使用潮国创意服务，如您不同意相关隐私政策内容的，请您立即停止使用潮国创意相关服务。您使用或继续使用潮国创意服务的行为视为您已充分理解并同意《潮国
              创意隐私政策》的全部内容。<br>
              3、如您对《潮国创意隐私政策》或对您的个人信息相关内容有任何问题的，您可通过潮国创意客服或以下联系方式联系我们。<br>
              #电子邮箱：248172239@qq.com
            </p>

            <p>
              十、未成年人条款<br>
              1、潮国创意注重未成年人的保护。若您为未成年人，您应在法定监护人监护、指导下阅读本协议，并在取得法定监护人的同意后使用潮国创意服务。<br>
              2、法定监护人应指导、提示被监护人注重网络安全问题。潮国创意不鼓励未成年人潮国创意服务进行任何消费行为，如未成年人确有此等需求的，应以法定监护人名义申请或在法定监护人明示同意下实施付费操作。未
              成年人就潮国创意服务的使用行为视为已获得了法定监护人认可。<br>
              3、潮国创意在此提醒未成年人，请您在使用潮国创意服务时，以利于学习为宗旨，不断提升自身的综合素养，切勿沉迷网络。<br>
              4、潮国创意将严格依据潮国创意所公示的《潮国创意隐私政策》相关条款严格保护未成年人隐私。
            </p>

            <p>
              十一、协议的修改与变更 <br>
              1、潮国创意有权随时修改本协议的任何条款，一旦本协议的内容发生变动，潮国创意将会通过适当方式向用户提示修改内容。<br>
              2、如您不同意潮国创意对本协议相关条款所作的修改，请您立即停止使用潮国创意服务，您继续使用潮国创意服务的行为视为您接受潮国创意对本协议相关条款所作的修改。
            </p>

            <p>
              十二、通知送达<br>
              1、本协议项下潮国创意对于您所有的通知均可通过网页公告、电子邮件或常规的信件传送等方式进行；该等通知发出之日视为送达之日。 <br>
              2、用户对于潮国创意的通知应当通过潮国创意对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达，如您通过其它非潮国创意官方渠道获得相关通知产生的不利后果由您自行承担。
            </p>

            <p>十三、争议解决及其它 <br>
              1、本协议的订立、解释和履行均适用中华人民共和国法律，如双方就本协议内容或其执行发生任何争议，应首先通过友好协商解决；协商不成的，任意一方均可向潮国创意所在地有管辖权的人民法院提起诉讼。<br>
              2、如本协议中的任何条款无论因何种原因完全或部分无效不影响其余条款的效力，双方仍应依据其余条款严格履行并受其约束。<br>
              3、本协议中的标题仅为方便各方阅读及理解而设，不得解释为双方达成的任何协议。<br>
              4、用户理解并同意，潮国创意有权根据用户选择购买的VIP会员服务内容（以潮国创意VIP充值页公布的内容为准）在部分用户下载的素材中添加带有“潮国创意”字样的水印或其他用于证明该素材来源于潮国创意的标识。<br>
              5、用户理解并同意，潮国创意出于自身利益保护及管理运营，为防止非法用户实施恶意下载、内容窃取等行为，可于潮国创意设置防盗刷系统，请您妥善使用账号下载功能，如您在使用过程中触发该机制，请您及时、主动
              联系潮国创意客服并提供相关证明，潮国创意将于合理期限内为您解除相关限制。如您确实存在合法开放使用需求的，您应提前向潮国创意提出开放申请，潮国创意有权根据该使用者的具体情况，自主决定是否开放下载限制。<br>
              #潮国创意电子邮箱：248172239@qq.com</p>

          </div>

          <!-- 版权声明 -->
          <div v-if="act == 1">
            <p>
              1、潮国创意（chaopx.com）为上海图魂网络科技有限公司所有并运营。潮国创意中所展示、传播的任何图片、图形、音频、字体、文本等设计素材及视频资料中所涉及的著作权、专利权、商标权、商业秘密等知识产权及其它信息内容均受版权、商标等现行相关法律保护，潮国创意就网站中所展示、传播的作品享有著作权或已获相关授权，但相关页面另有标注的除外。除本协议另有约定外，未经相关权利人同意，任何人不得使用、展示、传播潮国创意作品，不得将上述作品用于任何商业/非商业目的。
              <br>2、未经潮国创意许可，用户不得将潮国创意作品进行修改、改编、汇编，不得依据潮国创意作品进行二次创作，不得就相关作品进行表演、录制、发行。用户需确保潮国创意所提供的内容符合其使用需求，潮国创意就相关作品、资料与用户需求的使用契合度不作任何保证。
              <br>3、潮国创意为提供作品整体的艺术美感、使用价值而展示的任何软件的一切权利均属于该软件著作权人，未经权利人许可，用户不得对该软件进行使用、反汇编、反向编译、反向工程。
              <br>4、潮国创意鼓励用户对网站上的作品进行全面监督，潮国创意已通过用户协议等其它文件明确告知作者不得侵犯他人合法权益，潮国创意已设置专业岗位及专业审核人员就潮国创意所展示的作品进行定期/不定期审查，但因潮国创意图库庞大，潮国创意审核人员无法一一排除所有存在权属瑕疵作品。如依据《中华人民共和国著作权法》、《信息网络传播权保护条例》、《中华人民共和国民法典》（侵权责任编）及现行法律法规，您发现潮国创意存在侵犯您或任意第三方知识产权之行为，您可通过采取联系潮国创意客服或向潮国创意发送侵权通知等措施及时通知潮国创意进行下架，潮国创意将在收到您的侵权通知后合理期限内予以核实，如您所述情况属实，潮国创意将及时删除相关作品避免造成您的损失；但您已知悉，如相关行为人通过发送反通知方式向潮国创意提交相关材料的，潮国创意可恢复相关作品的展示、传播，由此产生的纠纷由您与上传者自行解决。您所提交的通知中应包含如下材料：
              <br>（1）个人身份证件/公司营业执照复印件（签字/加盖公章）；
              <br>（2）联系地址及联系方式；
              <br>（3）您所需删除的相关作品链接、名称及相关信息；
              <br>（4）可初步证明您为权利人的相关权属材料（包括但不限于首次发表记录、版权登记证书、作品源文件等）。
              <br>5、未经潮国创意许可，任何人不得通过爬虫程序、脚本、机器人程序等窃取潮国创意所展示、传播的作品，不得故意绕开潮国创意所设置的网络障碍侵犯潮国创意合法权益；不得复制、仿造潮国创意网站实施侵权行为。不得就潮国创意的源代码、网站技术措施进行反汇编、反向编译、反向工程等。
              <br>6、潮国创意用户均应于合理范围内使用潮国创意作品，因用户违约使用或超出相应授权范围使用相关作品所产生的一切不利后果均由用户自行承担，潮国创意不因此承担任何责任。
              <br>7、请您确保您已充分理解并同意本文档中相关表述，如您不接受本声明中部分或全部条款的，请您立即停止使用潮国创意服务，您注册潮国创意账号，使用潮国创意服务的行为视为您已知悉并同意遵守潮国创意相关条款。
              <br>版权投诉举报通道
              <!-- <br>电话：02161515010 （周一至周五 9:30—18:00） -->
              <br>邮箱：248172239@qq.com
            </p>
          </div>
          <!-- 隐私政策 -->
          <div v-if="act == 2">
            <p>上海图魂网络科技有限公司-潮国创意（chaopx.com）（以下简称“我们”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，
              恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
              请您在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。一旦您使用或继续使用我们的产品/服务，即表示您同意我们按照本隐私政策使用和处理您的相关信息。</p>

            <p>一、我们如何收集和使用您的个人信息
              <br>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
              <br>个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。
              <br>我们仅会出于本政策所述的以下目的，收集和使用您的个人信息/个人敏感信息：
              <br>（一）为您提供网上学习服务
              <br>1、业务功能一：注册成为用户
              <br>（1）为完成创建账号，您需提供以下信息：您的姓名、身份证号码、电子邮箱地址、手机号码、创建的用户名和密码等
              <br>（2）在注册过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：工作职位、公司、教育背景等。但如果您不提供这些信息，将不会影响使用本服务的基本功能。
              <br>（3）我们的产品若支持您使用第三方平台的账号（如微信账号/QQ账号）进行登录，如您使用第三方平台的账号登录的，我们可能将根据您的授权获取该第三方账号下的相关信息（包括：用户名、昵称、头像等）以及身份验证信息（个人敏感信息）。我们承诺，收集上述信息是用于为您提供账号登录服务以及保障您的账号安全，防范安全风险。如您拒绝授权此类信息，则您将无法使用第三方平台的账号登录我们平台。
              <br>（4）您需理解，手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是基于法律法规的相关要求，如您拒绝提供可能导致您无法注册账号或使用相关产品功能，请您谨慎考虑后再选择是否提供。
              <br>（5）您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息，注销/删除流程详见第五条第（三）款。
              <br>（6）上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。
              <br>2、业务功能二：
              <br>(1)搜索:当您在我们的产品中使用搜索功能时，我们需要收集您的一些信息，其中包括如下个人信息：您的设备信息、您的日志信息，包括您搜索的字或词、您的浏览记录和时间、您搜索的时间以及次数。我们收集这些信息是为了向您快速匹配您所需要的内容以及您可能感兴趣的内容，同时亦为了改进我们的产品和服务。
              <br>
              (2)商品展示、个性化推荐、广告宣传、发送促销营销信息，您已知悉并同意，我们可以依据自身的商业需求向您发送不特定的促销信息，当您对我们推荐的个性化内容不感兴趣或希望减少某些信息推荐时，您可通过向我们发送电子邮件或联系客服、自主取消、屏蔽等方式拒绝接收此等消息。
              <br>(3)客户服务：当您向我们发起投诉、申诉或进行咨询时，为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。同时，为了方便与您联系或帮助您解决问题，我们可能还需要您提供姓名、手机号码、电子邮件及其他联系方式等个人信息（个人敏感信息）。另外，我们还会收集您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）、与您的需求相关联的其他必要信息。我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。
              <br>
              (4)商品交易：当您在我们的产品与/或服务中购买部分增值商品或服务的，您需要根据提示提供一些与完成交易相关联的信息，如交易的商品或服务信息等。此外，我们也可能会再收集一些其他与订单相关的信息，包括：交易金额、下单时间、订单编号、订单状态、支付方式、支付流水号、支付状态，我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客户服务等。我们向您承诺，我们会以最大努力保障您的个人信息安全，不对外泄露或做其他任何用途。
              <br>
              需要特别提醒您的是：由于我们的产品和服务较多，为您提供的内容也不同，因此核心业务功能（包括其收集的您的个人信息类型）也会因产品/服务的内容不同而有所区别，具体以产品/服务实际提供为准。除此之外，您理解并同意，我们希望提供给您的产品和服务是完善的，所以我们会不断改进我们的产品和服务，包括技术，这意味着我们可能会经常推出新的业务功能，可能需要收集新的个人信息或变更个人信息使用目的或方式。
              <br>如果某一需要收集您的个人信息的功能或产品/服务未能在本隐私政策中予以说明的，我们会通过更新本政策、页面提示、弹窗、站内公告等方式另行向您说明该信息收集的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您明示同意后收集。在此过程中，如果您对相关事宜有任何疑惑的，可以通过本隐私政策第九条提供的方式联系我们，我们会尽快为您作出解答。
              <br>3、电子签约：
              <br>（1）您使用我们的部分产品、服务和/或向我们提供原创作品前，需通过在线电子签约系统完成电子签约，在使用在线电子签约系统时，依据相关法律法规，我们需要收集您的个人身份信息、个人生物识别信息以及个人财产信息，包括如下：电子合同文本、签署方信息（签署方姓名、住址及其联系电话）（个人敏感信息）、签署方的身份证号码（个人敏感信息）、面部识别特征（个人敏感信息）、银行账户（个人信息）。此外，我们也可能会再收集一些其他与电子签约相关的信息，包括：合同金额、合同期限、签约时间、合同编号、合同状态、支付方式、支付流水号、支付状态，我们收集这些信息是为了帮助您顺利完成电子签约、保障您的签约安全、查询合同信息、提供合同管理服务等。
              <br>
              （2）您使用在线电子签约系统时，为了完成实名认证服务，我们将依据相关法律法规，根据不同的认证方式按需向在线电子签约系统供应商提供您的个人身份信息、个人生物识别信息以及个人财产信息，包括如下：签署方信息（签署方姓名、联系电话）（个人敏感信息）、签署方的身份证号码（个人敏感信息）、面部识别特征（个人敏感信息）、银行账户（个人信息）；为了准确验证您的身份，在线电子签约系统供应商需将上述信息提供给合法存有您个人信息的第三方机构（有关政府部门、电信运营商、中国银联、支付宝）进行比对核验。我们向您承诺，我们会以最大努力保障您的个人信息安全，严格要求在线电子签约系统供应商对您的个人信息保密，只以实名认证之目的获悉和使用，不得对无关方泄露或做其他任何用途。
              <br> 4、实名认证：
              <br>（1）您使用我们的部分产品与/或服务时，需要根据相关法律规定以及我们的指引完成实名认证程序，您也可自行通过【潮国创意签约设计师申请】页面使用实名认证服务。为了完成实名认证服务，我们将依据相关法律法规获取您的个人身份信息、个人生物识别信息等，包括如下：姓名、身份证件号码（个人敏感信息）、面部识别特征（个人敏感信息）。为了准确验证您的身份，我们需将上述信息传输给合法存有您个人信息的第三方机构（有关政府部门）进行比对核验。我们向您承诺，上述信息仅用于实名认证之目的，完成身份核验后将立即自行并要求第三方机构予以删除；但是，为了履行存储注册信息义务，我们将存储您的姓名（个人敏感信息）、身份证件号码（个人敏感信息）。
              <br>（2）您理解并确认，我们会以最大努力保障您的个人信息安全，并严格要求第三方机构对您的个人信息保密，只以实名认证之目的获悉和使用，不得对无关方泄露或做其他任何用途。
              <br>（3）同时，您需理解，姓名、身份证件号码、面部识别特征、您手持身份证件的照片属于您的个人敏感信息，我们收集该类信息是基于实名认证程序要求，如您拒绝提供可能导致您无法登录账号并使用相关产品功能，请您谨慎考虑后再选择是否提供。
              <br> 5、支付功能：
              <br>当您在我们客户端上开通服务、订购商品等发生支付行为时，需要用到支付功能。在支付过程中，我们可能会收集您的第三方支付渠道的user ID (例如支付宝user ID、微信open
              ID信息)（个人敏感信息）。上述信息为我们向您提供您购买商品和/或服务所必须的信息，我们无法仅根据该信息获得您的个人财产信息，也不能识别特定自然人身份信息。如果您不同意我们收集上述信息，您将无法使用部分产品和/或服务包含的互动功能，但不影响您使用我们为您提供的其他产品和服务。
              <br>（二）开展内部数据分析和研究，第三方SDK统计服务，改善我们的产品或服务【注：示例】
              <br> 1、我们收集数据是根据您与我们的互动和您所做出的选择，包括您的隐私设置以及您使用的产品和功能。我们收集的数据可能包括SDK/API/JS代码版本、浏览器、互联网服务提供商、
              IP地址、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、iOS广告标识符（IDFA)、安卓广告主标识符、网卡（MAC）地址、
              国际移动设备识别码（IMEI）、设备型号、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。
              <br>我们接入的授权合作伙伴所使用的SDK有：
              <br>（1）羡云平台短信登录
              <br>所属主体：上海羡云网络科技有限公司
              <br>主要收集的个人信息：手机号
              <br>（2）支付宝支付
              <br>所属主体：支付宝（中国）网络技术有限公司
              <br>主要收集的个人信息：无
              <br>隐私政策地址：https://render.alipay.com/p/c/k2cx0tg8
              <br>（3）微信支付
              <br>所属主体：深圳市腾讯计算机系统有限公司
              <br>主要收集的个人信息：无
              <br> 隐私政策地址：
              <br>https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy
              <br>（4）极验验证
              <br> 所属主体：武汉极意网络科技有限公司
              <br>主要收集的个人信息：无
              <br>隐私政策地址：https://www.geetest.com/Private
              <br>（5）法大大（签约）
              <br>所属主体：深圳法大大网络科技有限公司
              <br>主要收集的个人信息：手机号，身份证信息，银行卡信息（个人敏感信息）
              <br>隐私政策地址：https://v3.fadada.com/usesecret/
              <br>（6）客服接入
              <br>所属主体：北京沃丰时代数据科技有限公司
              <br>主要收集的个人信息：无
              <br> 隐私政策地址：https://www.udesk.cn/terms_service.html
              <br> 2、当我们要将信息用于本策略未载明的其它用途时，会事先征求您的同意。
              <br>3、当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
            </p>

            <p>二、我们如何使用 Cookie 和同类技术

              <br>（一）Cookie

              <br>1、为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于
              Cookie，网站能够存储您的偏好或购物篮内的商品等数据。

              <br>2、我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie
              的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。

              <br>（二）网站信标和像素标签

              <br>除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。
              如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。
              借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。

              <br>（三）Do Not Track（请勿追踪）

              <br>很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not Track 请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了 Do
              Not Track，那么我们的所有网站都会尊重您的选择。</p>

            <p>三、我们如何共享、转让、公开披露您的个人信息
              <br>（一）共享
              <br>我们不会向其他任何公司、组织和个人分享您的个人信息，但以下情况除外：
              <br>1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
              <br>2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
              <br> 3、与我们的关联公司共享：您的个人信息可能会与我们关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
              <br>4、与授权合作伙伴共享：仅为实现本隐私权政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，我们聘请来提供第三方数据统计和分析服务的公司可能需要采集和访问个人数据以进行数据统计和分析。在这种情况下，这些公司必须遵守我们的数据隐私和安全要求。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。
              <br>5、对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
              <br>
              6、委托我们进行信息推广和广告投放的合作伙伴：您确认我们有权与委托我们进行信息推广和广告投放的合作伙伴共享我们使用您的相关信息集合形成的去标识化或匿名化处理后的分析/统计类信息，以帮助其进行广告或决策建议、提高广告有效触达率、进一步了解用户需求。我们承诺：未经您的同意，我们不会与其共享可以识别您身份的个人信息。
              <br>7、在法律要求或允许的范围内，为了保护我们及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方。
              <br>（二）转让
              <br> 1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。
              <br>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
              <br>（三）公开披露
              <br>公开披露是指向社会或不特定人群发布信息的行为。除了因需要对违规账号、欺诈行为等进行处罚公告、公布中奖/获胜者等名单时脱敏展示相关信息等必要事宜而进行的必要披露外，我们不会对您的个人信息进行公开披露，如具备合理事由确需公开披露的，我们会在公开披露前向您告知公开披露的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的授权同意后再公开披露，但在获得您明确同意、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下除外。
            </p>
            <p>四、我们如何保护您的个人信息
              <br>（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
              我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受 SSL 加密保护； 我们同时对我们网站提供 https
              安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；
              我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
              <br>（二）我们在为您提供满足产品和服务目的所必需且最短的期间内保留您的个人信息，例如：当您使用我们的注册及会员功能时，我们需要收集您的手机号码，且在您提供后并在您使用该功能期间，我们需要持续保存您的手机号码，以向您正常提供该功能、保障您的账号和系统安全。此外，我们或对您的相关信息保存至相关法律所规定的必要期限（例如《电子商务法》规定：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年）。
              <br>（三）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
              <br>（四）互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他我们用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。
              <br>（五）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
              <br>（六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
              <br>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 </p>

            <p>五、您的权利
              <br>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
              <br>（一）访问您的个人信息
              <br>（1）您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
              <br>账户信息——如果您希望访问或编辑您的账户中的个人资料信息和支付信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过访问 潮国创意个人中心 执行此类操作。
              <br>如果您无法通过上述链接访问这些个人信息，您可以随时使用我们的 Web 表单联系，或发送电子邮件至248172239@qq.com。我们将在30天内回复您的访问请求。
              <br>（2）对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请发送电子邮件至248172239@qq.com。
              <br>（二）更正您的个人信息
              <br>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问您的个人信息”中罗列的方式提出更正申请。
              <br>如果您无法通过上述链接更正这些个人信息，您可以随时使用我们的 Web 表单联系，或发送电子邮件至248172239@qq.com。我们将在30天内回复您的更正请求。
              <br> （三）删除您的个人信息
              <br> 在以下情形中，您可以向我们提出删除个人信息的请求：
              <br> 1、如果我们处理个人信息的行为违反法律法规；
              <br> 2、如果我们收集、使用您的个人信息，却未征得您的同意；
              <br> 3、如果我们处理个人信息的行为违反了与您的约定；
              <br> 4、如果您不再使用我们的产品或服务，或您注销了账号；
              <br> 5、如果我们不再为您提供产品或服务。
              <br>
              您可通过潮国创意联系客服提交您的注销申请或向潮国创意邮箱248172239@qq.com发送邮件申请删除您的个人信息。潮国创意在收到您的注销/删除请求后，我们将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
              当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。

              <br> （四）改变您授权同意的范围
              <br> 每个业务功能需要一些基本的个人信息才能得以完成（见本策略“第一部分”）。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。
              <br> 您可以通过以下方式自行操作：
              <br> 访问 潮国创意个人中心 进行修改
              <br> 当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
              <br>（五）个人信息主体注销账户
              <br>您随时可注销此前注册的账户，您可以通过以下方式自行操作：
              <br>1、联系潮国创意客服进行注销；
              <br> 2、向我们发送电子邮件（248172239@qq.com）申请注销；
              <br> 3、在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求删除您的个人信息，法律法规另有规定的除外。
              <br> 4、在技术可行的前提下，例如数据接口匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方，但未经您的明确许可，我们不会将相关信息提供给任意第三方。
              <br> （六）约束信息系统自动决策
              <br> 在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。
              <br> （七）响应您的上述请求
              <br> 为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
              <br> 我们将在三十天内做出答复。如您不满意，还可以通过以下途径投诉：
              <!-- <br> 电话：021-61515010  -->
              <br> 邮箱：248172239@qq.com
              <br>
              对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
              <br> 在以下情形中，按照法律法规要求，我们将无法响应您的请求：
              <br> 1、与国家安全、国防安全有关的；
              <br> 2、与公共安全、公共卫生、重大公共利益有关的；
              <br> 3、与犯罪侦查、起诉和审判等有关的；
              <br> 4、有充分证据表明您存在主观恶意或滥用权利的；
              <br> 5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
              <br> 六、我们如何处理儿童/未成年人的个人信息
              <br>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。
              <br> 对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
              <br> 如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
              <br> 对于可能涉及的不满14周岁的儿童个人信息保护，请参考此处详细了解：《潮国创意儿童个人信息保护规则》
            </p>

            <p>七、您的个人信息如何在全球范围转移
              <br>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。
              <br>由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。
              <br>此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。
            </p>
            <p>八、本隐私权政策如何更新
              <br>我们可能适时会对本隐私权政策进行调整或变更，本隐私权政策的任何更新将以标注更新时间的方式公布在我们网站上，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表您已充分阅读、理解并接受修改后的隐私权政策并受其约束。
            </p>
            <p>九、如何联系我们
              <br>如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：
              <!-- <br>1、电话：021-61515010  -->
              <br> 2、电子邮箱：248172239@qq.com
              <br>我们设立了个人信息保护专职部门（或个人信息保护专员），您可以通过以下方式与我们联系：
              <!-- <br>1、联系电话：021-61515010  -->
              <br>2、电子邮箱：248172239@qq.com
            </p>

            <p>十、争议解决
              <br>1、本隐私政策的解释及争议解决均应适用中华人民共和国大陆地区法律。任何因本隐私政策以及我们处理您个人信息事宜引起的争议，您同意向上海仲裁委员会提起仲裁解决；该仲裁一裁终局，对双方均具有法律约束力。
              <br>2、如果您认为我们处理个人信息的行为损害了您的合法权益，您也可以选择向有关政府部门进行反映。
              <br>3、本隐私政策的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。
            </p>


            <p>《潮国创意儿童个人信息保护规则》
            </p>

            <p>
              上海图魂网络科技有限公司（以下简称“我们”）作为潮国创意经营者，深知保护儿童（指未满十四周岁的未成年人，下同）个人信息安全和隐私的重要性，取得监护人的理解与配合对我们保护儿童个人信息及隐私安全非常必要。本规则适用于上海图魂网络科技有限公司在中华人民共和国境内通过网络从事收集、存储、使用、转移、分享和披露儿童个人信息等活动。本规则系基于《隐私政策》所订立的特别规则，如本规则与《隐私政策》存在冲突的以本规则为准，本规则未予载明的请参照适用《隐私政策》。
            </p>
            <p>
              如您为儿童监护人的，请您及儿童在使用潮国创意服务时仔细阅读《隐私政策》及本规则，并在充分理解并认可全部条款后再允许儿童使用潮国创意服务。为维护儿童合法权益，潮国创意希望您可以协助我们在确保儿童在您的同意及指导下向我们提交使用者信息及使用潮国创意服务，我们将依据本规则就所获取的儿童信息采取特殊保护机制，如您不同意本规则或潮国创意《隐私政策》的，请您要求儿童立即停止使用潮国创意服务。
            </p>
            <p>
              如您为儿童的，请您知悉，任何儿童参加互联网活动均需取得监护人的事先认可；请您务必通知您的监护人并共同阅读本规则及潮国创意《隐私政策》，并在您的监护人同意与指导下使用我们的产品及服务、提交个人信息。
            </p>

            <p>
              如您对本规则有任何问题的，请您随时通过本规则章末所列联系方式联系我司，我们将尽快予以解答。
            </p>

            <p>
              （一）如何收集、使用儿童个人信息 <br />
              1、我们将遵循正当必要、知情同意、目的明确、安全保障、依法利用原则，严格履行法律法规规定的儿童个人信息保护义务与责任，在取得监护人同意后方收集及使用儿童个人信息。如您在使用我们的产品或服务过程中主动上传、提交儿童相关的诸如相片、视频等信息的，表示您认可我们收集及依据本规则使用您所上传的儿童个人信息。
              <br />
              2、当您或儿童使用潮国创意服务时，为提供更加安全的信息保障服务及良好的服务产品与服务质量（如个性化推荐等），我们可能会基于此收集和使用其他儿童个人信息，具体使用目的请参照《隐私政策》相关条款。此外，我们同时会通过Cookies、SDK等同类技术自动收集您或儿童的个人信息，请您参照《隐私政策》中“我们如何使用Cookies”，如我们所收集和使用儿童个人信息超出上述范围的，我们将再次征得监护人的许可。
              <br />
              请您理解，基于客观因素，潮国创意在绝大多数情形下无法识别及判断所收集与处理的个人信息是否属于儿童个人信息，因此我们将依据《隐私政策》就相关信息予以收集与处理。
              <br />
              3、例外情形 <br />
              依据相关法律法规之规定，如基于以下情形需要收集、处理个人信息的，我们或不会征得监护人同意。<br />
              （1）基于国家安全、国防安全、公共安全、公共卫生、重大公共利益而收集的；<br />
              （2）基于刑事犯罪中的侦查、起诉、审判、判决与执行而无法事先取得监护人同意的；<br />
              （3）基于维护儿童生命、财产等重大合法权益而难以获取监护人同意的；<br />
              （4）所收集信息系已由儿童或监护人自行向社会公众公开的；<br />
              （5）自诸如新闻报导、政府信息公开等合法公开披露信息中所收集及获取的；<br />
              （6）学术研究机构基于公共利益开展统计或学术研究之必要且已进行匿名化处理的；<br />
              （7）基于法律法规及为签署相关书面文件所必需的；<br />
              （8）法律法规规定的其他情形。<br />
            </p>

            <p>
              （二）如何共享、转让、公开披露儿童个人信息 <br />
              1、潮国创意承诺对所收集的儿童个人信息进行严格保密，仅在符合本规则且取得您明确许可情形下我们才会依据具体情形决定是否共享儿童个人信息。<br />
              2、基于《隐私政策》已有明确约定基础上，我们对于儿童个人信息仍将采取如下措施以保护儿童个人信息在共享、转让及公开披露过程中的安全。<br />
              （1）在基于本规则所述目的及符合法定与本规则约定之基础上，如我们需将儿童个人信息共享至第三方的，我们将通过该接收方接收信息之合法性、正当性及必要性角度进行评估，同时我们在提供前会依法取得您的同意或确认该接收方已取得您的同意。<br />
              （2）我们将要求信息接收之第三方就所获取的儿童个人信息采取严格的保密措施，遵守相关法律法规、贯彻监管要求，禁止任何接收方未经儿童及监护人许可使用儿童个人信息。<br />
              （3）接收方需满足如下全部要求，否则我们不会向其共享任何儿童信息：<br />
              ①遵守相关法律法规、严格履行潮国创意要求收集、处理儿童个人信息；<br />
              ②具有严格的儿童个人信息保护措施，建立信息泄露应急预案，如发生信息泄露需立即向主管单位履行报告义务并同时通知我们；<br />
              ③与我们共同积极响应儿童及监护人提出有关儿童个人信息的申请；<br />
              ④在终止合作时立即永久性删除所获取的儿童个人信息；<br />
              ⑤不得将所获取的儿童个人信息进行转委托；<br />
              ⑥严格履行其他法定儿童个人信息保护义务。<br />
            </p>

            <p>
              （三）如何储存儿童个人信息 <br />
              1、潮国创意在中华人民共和国境内经营所获取的儿童个人信息将全部储存于中华人民共和国境内，除应相关法律法规要求、获得您的单独许可或儿童主动发起跨境请求外，我们不会向任何境外组织或个人提供任何儿童个人信息。<br />
              2、除法律另有强制性规定外，我们将尽力避免收集与处理无关儿童个人信息并仅在为达成本规则之目的及提供服务期限内保留儿童个人信息在达成本规则所述目的所需的期限内保留儿童的个人信息；如潮国创意停止运营的，我们会立即停止一切收集与处理儿童个人信息的活动并依法通知监护人，除法律法规或监管部门另有规定外，我们会同时就所收集的儿童个人信息采取删除或匿名化处理。<br />
            </p>

            <p>
              （四）如何保护儿童个人信息 <br />
              1、限制访问权限 <br />
              我们将严格控制儿童个人信息访问权限并采取最小够用授权原则，同时对于任何处理儿童个人信息的行为均进行记录与管控。<br />
              2、制定应急预案 <br />
              针对儿童个人信息安全事件建立单独预案，并不定期组织相关安全负责人及儿童信息处理人员进行培训及演练；如发生儿童信息安全事件，我们将依法第一时间向主管单位及监护人履行报告义务；报告方式包括但不限于书面报告、短信、电子邮件等；如该事件造成儿童及其监护人合法权益受损的，我们将积极履行相关法律责任。
            </p>

            <p>
              （五）如何管理儿童个人信息 <br />
              1、为便利监护人及儿童访问、管理个人信息，同时保障监护人及儿童合法权利，您可参照《隐私政策》相关条款就儿童个人信息进行管理。
              <br />
              2、如您存在如下情形需删除相关儿童个人信息的，可依据本规则第（六）项所示方式联系我们，我们将在第一时间响应您的需求。
              <br />
              （1）潮国创意存在违反相关法律法规或双方就儿童个人信息的约定处理儿童个人信息情形的；
              <br />
              （2）潮国创意超出约定范围或超出必要程度收集及处理儿童个人信息的；
              <br />
              （3）监护人或儿童撤回个人信息授权/同意的； <br />
              （4）监护人或儿童注销账号停止使用潮国创意提供的网络服务的。 <br />
            </p>

            <p>
              （六）联系我们 <br />
              如监护人或儿童对本规则存在任何疑问，或对我们处理儿童个人信息存在任何意见或建议的，可随时通过以下渠道联系我们，我们将在收到您的问题、意见或建议且在您提供必要的身份验证信息后尽快回复您的请求，该回复期限最多不超过十五日。
            </p>

            <p>
              1、电子邮箱：1819048556@qq.com <br />
              2、书面函件地址：上海市浦东新区碧波路690号1幢102室上海图魂网络科技有限公司法务部。
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import indexExtend from "../common/protocol-extend";

export default {
  name: "CommonProblem",
  mixins: [indexExtend],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    act: 0
  },
  data() {
    return {
      tab: [
        "用户协议",
        "版权声明",
        "隐私政策",
      ]
    }
  },
  mounted() {
    this.headline = this.tab[this.act];
  }

}
</script>

<style lang="scss" scoped>
@import "pages/protocol/common/common";


</style>
